var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3DotsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3,
    height: 11,
    viewBox: "0 0 3 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1623",
    transform: "translate(-968 -292)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 44",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(968 292)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 45",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(968 296)"
  }), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 46",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(968 300)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DotsIcon);
export default __webpack_public_path__ + "static/media/3dots-icon.929a871a2cc183cb26504ee298eb8905.svg";
export { ForwardRef as ReactComponent };